import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSimpleStepItem from "../../components/simple-steps/FormAddEditSimpleStepItem";

const CreateSimpleStepItem = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/simple-steps");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSimpleStepItem
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateSimpleStepItem;
